import RelationContentList from 'components/RelationContentList'
import { Relation } from 'types/app'
import { DASHBOARD_SECTIONS } from 'types/enums'
import useTodo from 'hooks/useTodo'

interface Props {
	relations: Relation[]
}

const Waiting = ({ relations }: Props): JSX.Element => {
	useTodo(relations?.length, 2, 'APP_WAITING_LABEL', DASHBOARD_SECTIONS.CASTING)

	return <RelationContentList relations={relations} showUser={false} />
}

export default Waiting
